'use client';
import { Lists } from '.generated/Feature.CW.model';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import React, { JSX } from 'react';
import { ComponentProps } from 'lib/component-props';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { tv } from 'tailwind-variants';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import ComponentWrapper from 'helpers/SitecoreWrappers/ComponentWrapper/ComponentWrapper';
import useIsEditing from 'lib/hooks/useIsEditing';
import classNames from 'classnames';

export type CardListProps = Lists.NavigationCardList &
  ComponentProps & {
    params: {
      Theme: string;
    };
    isSidenavPart?: boolean;
  };

const NavigationCardList = (props: CardListProps): JSX.Element => {
  const { cardListWrapper, headingClass, descriptionClass } = TailwindVariants();
  const { DynamicPlaceholderId, RenderingIdentifier } = props?.params || {};
  const phKey = `cardlist-${DynamicPlaceholderId}`;
  const twoColumns = props?.params?.numberOfColumns;
  const gridColumnsClass =
    twoColumns === 'Two' ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-3';

  const isEditing = useIsEditing();

  return (
    <ComponentWrapper params={props?.params} isSidenavPart={props?.isSidenavPart}>
      <div className={cardListWrapper()} id={RenderingIdentifier}>
        {(props?.fields?.heading?.value !== '' || isEditing) && (
          <h2 className={headingClass()}>
            <PlainTextWrapper field={props?.fields?.heading} />
          </h2>
        )}

        {(props?.fields?.heading?.value !== '' || isEditing) && (
          <p className={descriptionClass()}>
            <PlainTextWrapper field={props?.fields?.description} />
          </p>
        )}

        <div
          className={classNames(
            'max-w-[1280px] mx-auto mt-16',
            isEditing
              ? `[&>div]:grid [&>div]:grid-cols-1 [&>div]:gap-[21px] ${twoColumns === 'Two' ? '[&>div]:md:grid-cols-2' : '[&>div]:md:grid-cols-3'} [&>div>div]:col-span-1 ${twoColumns === 'Two' ? '[&>div_.ee-help-text-block]:col-span-2' : '[&>div_.ee-help-text-block]:col-span-3'} `
              : `grid gap-[21px] ${gridColumnsClass}`,
            ``
          )}
        >
          <PlaceholderWrapper
            name={phKey}
            rendering={props.rendering}
            varient={props?.params?.FieldNames}
          />
        </div>
      </div>
    </ComponentWrapper>
  );
};

export const Default = withStandardComponentWrapper(NavigationCardList);
export const ExpandedVersion = withStandardComponentWrapper(NavigationCardList);
export const CondensedVersion = withStandardComponentWrapper(NavigationCardList);

export const TailwindVariants = tv({
  slots: {
    cardListWrapper: 'mx-auto max-w-screen-xxl lg:px-20 px-10',
    headingClass: 'text-gray-900 font-centuryGothic text-26 leading-[32px] font-bold mb-[16px]',
    descriptionClass: 'text-gray-900 font-nunitoSans font-[500] text-16 leading-25 mb-[32px]',
  },
});
